module.exports = __webpack_public_path__ + "static/media/fysical.bfbdec11.png";